import React from "react";
import Slider from "react-slick";

export default function Sliders() {
  var settings = {
    dots: true,
    centerMode: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <div className="slider">
        <div className="container-fluid p-5">
          <div className="row">
            <div className="col-12 text-center">
              <h1>Overview</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Slider {...settings}>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0002.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0003.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0004.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0005.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0006.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0007.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="p-2">
                  <img
                    src="./images/slider_images/0008.jpg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
